<section class="why-choose-us-section">
  <div class="text-content">
    <app-badge text="Por qué elegirnos"></app-badge>
    <h2 class="title">Conoce Nuestros diferenciales ¿Por qué elegirnos?</h2>
    <p>Nuestra diferencia no está únicamente en lo que construimos, sino en la forma en que concebimos, planificamos y
      ejecutamos cada obra: con rigor técnico, visión de largo plazo y un compromiso absoluto con los resultados.</p>
  </div>
  <div class="cards-container">
    <div class="card card-1">
      <span class="number number-1">01</span>

      <!-- Carrusel de logos -->
      <div class="logos-wrapper">
        <div class="logo-carousel logo-carousel-row1">
          <div class="logo-track">
            <div class="logo-item" *ngFor="let brand of row1Brands">
              <img [src]="brand.src" [alt]="brand.alt" width="90" height="90" loading="lazy" decoding="async">
            </div>
          </div>
        </div>
        <div class="logo-carousel logo-carousel-row2">
          <div class="logo-track">
            <div class="logo-item" *ngFor="let brand of row2Brands">
              <img [src]="brand.src" [alt]="brand.alt" width="90" height="90" loading="lazy" decoding="async">
            </div>
          </div>
        </div>
      </div>

      <h3>Trayectoria que respalda decisiones estratégicas</h3>
      <p>
        Nuestra trayectoria nos permite comprender la complejidad técnica, operativa y financiera de cada proyecto,
        anticipar riesgos y ofrecer soluciones sólidas desde las primeras etapas.
        Para nuestros clientes, esto significa tomar decisiones con mayor certeza y menor exposición al riesgo.</p>

    </div>
    <div class="card" >
      <span class="number number-1">02</span>
      <h3 class="title-card" >Enfoque integral de ingeniería y gestión de proyectos</h3>
      <p>Operamos bajo un modelo que integra ingeniería, planeación, ejecución y control. Con metodologías claras aseguramos alcance definido, costos y tiempos controlados, supervisión técnica constante y comunicación efectiva con el cliente. Así transformamos ideas en proyectos ejecutables y resultados medibles.</p>
    </div>
    <div class="card cad-img">
      <img src="assets/images/home/why-card-1.webp" alt="Imagen 3" class="card-image" loading="lazy" decoding="async">
    </div>
    
    <div class="card cad-img">
      <img src="assets/images/home/why-card-2.webp" alt="Imagen 3" class="card-image" loading="lazy" decoding="async">
    </div>

    <div class="card card-3">
      <span class="number number-1">03</span>
      <h3 class="title-card" >Excelencia Operativa en calidad y seguridad</h3>
      <p>La calidad y la seguridad son principios que guían cada proyecto. Aplicamos procesos alineados a normas del sector y a las necesidades de cada cliente. Nuestra cultura preventiva y de mejora continua asegura entornos seguros, procesos controlados y resultados consistentes, porque entendemos que un accidente siempre es demasiado.</p>
    </div>

    <div class="card">
      <span class="number">04</span>
      <lucide-icon name="handshake" [size]="80" class="card-icon"></lucide-icon>
      <h3>Relaciones de largo plazo basadas en confianza</h3>
      <p>Estructura empresarial con esencia familiar Nuestra combinación de disciplina técnica y cercanía nos permite ofrecer atención personalizada, decisiones ágiles y responsabilidad institucional. Para nuestros clientes, esto significa trato directo con quienes deciden y compromiso real en cada proyecto</p>
    </div>
    <div class="card">
      <span class="number">05</span>
      <lucide-icon name="award" [size]="80" class="card-icon"></lucide-icon>
      <h3>Estructura empresarial con esencia de empresa</h3>
      <p>La calidad y la seguridad son principios que guían cada proyecto. Aplicamos procesos alineados a normas del sector y a las necesidades de cada cliente. Nuestra cultura preventiva y de mejora continua asegura entornos seguros, procesos controlados y resultados consistentes, porque entendemos que un accidente siempre es demasiado.</p>
    </div>
    
  </div>
</section>
